/** Get the number of days between two dates  */
export const getDaysBetween = (d1: Date, d2: Date) => {
  const diff = d1.getTime() - d2.getTime()
  return diff / (1000 * 60 * 60 * 24)
}

/** Get time difference between two dates in seconds */
export const getDiffInSeconds = (start: Date, end: Date) => {
  const seconds = (end.getTime() - start.getTime()) / 1000
  return seconds
}
